angular
	.module 'App.Component'
	.component 'toastFlyout',
		{
			templateUrl: '@component/toast-flyout/toast-flyout.view.html'
			controller: 'ToastFlyoutController'
			controllerAs: 'toastFlyout'
		}

class ToastFlyoutController extends AbstractController
	@register()
	@inject '$timeout', 'ToastService'

	initialize: ->
		@toasts = []
		@toastIndex = 1

		@ToastService.subscribe (toast) =>
			toast.id ?= "toast-#{@toastIndex}"
			@toastIndex++

			@toasts.push toast

			@$timeout(
				=>
					@remove(toast)
				,
				toast.ttl
			)

	remove: (toast) ->
		@toasts = _.reject(@toasts, {id: toast.id})
